'use strict';

const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const AddFeed = forgeUiComponent('AddFeed', {
  subscribing: 'is-subscribing'
}, function AddFeedConstructor() {
  const self = this;
  const subscribeButton = this.element.querySelector('.AddFeed-subscribeButton') || document.createElement('div');

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.subscribing = false;
  });

  subscribeButton.addEventListener('click', function openSubscribeDialog(e) {
    e.preventDefault();
    self.subscribing = true;
  });
});

module.exports = AddFeed;
